import { gql } from 'graphql-request'
import { loginServiceGraphql } from '../config/Config';


export const allBusinessType = async () => {
  const GET_BUSINESS_TYPE = gql`
  query AllBusinessType {
    allBusinessType {
      id
      content
    }
  }
    `;
  try {
    const response = await loginServiceGraphql.request(GET_BUSINESS_TYPE);
    return response.allBusinessType;
  } catch (error) {
    return error

  }
};


export const allIndustries = async () => {
  const GET_INDUSTRY = gql`
  query AllIndustries {
    allIndustries {
      id
      content
    }
  }
  
    `;

  const response = await loginServiceGraphql.request(GET_INDUSTRY);
  return response.allIndustries;
};

export const allCountries = async () => {
  const GET_INDUSTRY = gql`
  query AllCountries {
    allCountries {
      id
      name
      continent
      created_at
  
    }
  }
  
    `;

  const response = await loginServiceGraphql.request(GET_INDUSTRY);
  return response.allCountries;
};


export const stateFilter = async (data) => {
  const STATE_FILTER = gql`
  query AllStates($filter: StateFilter) {
    allStates(filter: $filter) {
      id
      name
      countryID
      created_at
    }
  }
       `;

  const response = await loginServiceGraphql.request(STATE_FILTER, data);
  return response.allStates;
};


export const cityFilter = async (data) => {
  const CITY_FILTER = gql`
  query AllCities($filter: CityFilter) {
    allCities(filter: $filter) {
      id
      name
      stateID
      created_at
    }
  }
  
       `;

  const response = await loginServiceGraphql.request(CITY_FILTER, data);
  return response.allCities;
};


export const verifyPhoneSignUp = async (data) => {
  const PHONE = gql`
  mutation GenerateOtpWithoutAccount($phone: String!) {
    generateOtpWithoutAccount(phone: $phone) {
      id
      phone
      code
      appID
      token
      updated_at
      created_at
      status
    }
  }
  `;

  const response = await loginServiceGraphql.request(PHONE, data);
  return response.generateOtpWithoutAccount;
};



export const createAllMerchant = async (data) => {
  const ALL_MERCHANT = gql`
  mutation CreateAllMerchant($data: MerchantCreateAllInput!) {
    createAllMerchant(data: $data) {
      id
      brc_number
      name
      type
      country
      brand
      industry
      status
      employeeID
      mdrID
      created_at
      updated_at
      }
  }
  
  `;
  const response = await loginServiceGraphql.request(ALL_MERCHANT, data);
  return response.createAllMerchant;
};


export const verifyOtpSignUp = async (data) => {
  const VERIFY_OTP = gql`
  mutation VerifyOtp($data: VerifyOtpInput!) {
    verifyOtp(data: $data) {
      phone
      status
      type
    }
  }
  `

  const response = await loginServiceGraphql.request(VERIFY_OTP, data);
  return response.verifyOtp;
};


export const verifyEmail = async (data) => {
  const VERIFY_EMAIL = gql`
  mutation VerifyEmail($email: String!) {
    verifyEmail(email: $email) {
      isExist
    }
  }
  `

  const response = await loginServiceGraphql.request(VERIFY_EMAIL, data);
  return response.verifyEmail;
};
